import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// Evento do Chrome/Android; não faz parte dos tipos padrão do DOM
export interface BeforeInstallPromptEvent extends Event {
	prompt: () => Promise<void>
	userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

interface PwaInstallState {
	deferredPrompt: BeforeInstallPromptEvent | null
	// Só vale para o navegador atual: no iOS o app instalado tem storage separado do Safari
	installed: boolean
	bannerDismissed: boolean
	iosGuideOpen: boolean
	setDeferredPrompt: (event: BeforeInstallPromptEvent | null) => void
	markInstalled: () => void
	dismissBanner: () => void
	setIosGuideOpen: (open: boolean) => void
}

export const usePwaInstallStore = create<PwaInstallState>()(
	persist(
		(set) => ({
			deferredPrompt: null,
			installed: false,
			bannerDismissed: false,
			iosGuideOpen: false,
			setDeferredPrompt: (deferredPrompt) => set({ deferredPrompt }),
			markInstalled: () => set({ installed: true, deferredPrompt: null }),
			dismissBanner: () => set({ bannerDismissed: true }),
			setIosGuideOpen: (iosGuideOpen) => set({ iosGuideOpen }),
		}),
		{
			name: 'ssma-pwa-install',
			partialize: ({ installed, bannerDismissed }) => ({
				installed,
				bannerDismissed,
			}),
		},
	),
)

// Registrado no carregamento do módulo: o evento pode disparar antes do React montar o menu
if (typeof window !== 'undefined') {
	window.addEventListener('beforeinstallprompt', (event) => {
		event.preventDefault()
		usePwaInstallStore
			.getState()
			.setDeferredPrompt(event as BeforeInstallPromptEvent)
	})
	window.addEventListener('appinstalled', () => {
		usePwaInstallStore.getState().markInstalled()
	})
}
